import React, { useEffect, useMemo, useState } from 'react';
import api from '../services/api';
import ReportPrintLayout from '../components/ReportPrintLayout';

const ReportsInventoryPrint = () => {
  const getCurrentMonthRange = useMemo(() => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    const toISODate = (d) => {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    };
    return { start: toISODate(start), end: toISODate(end) };
  }, []);

  const [dateRange, setDateRange] = useState({ start: getCurrentMonthRange.start, end: getCurrentMonthRange.end });
  const [reportData, setReportData] = useState(null);

  const fetchInventoryReport = async () => {
    try {
      const res = await api.get('/inventory-report/report', {
        params: { startDate: dateRange.start, endDate: dateRange.end },
      });
      setReportData(res.data);
    } catch (e) {
      setReportData(null);
    }
  };

  useEffect(() => {
    fetchInventoryReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange.start, dateRange.end]);

  // Prepare data for the print layout
  const printData = reportData ? {
    summary: {
      total_items: reportData.summary?.total_items,
      inventory_value: reportData.summary?.inventory_value,
      low_stock_count: reportData.summary?.low_stock_count,
      out_of_stock_count: reportData.summary?.out_of_stock_count || 0,
      best_selling_count: reportData.top_products?.length || 0,
      slow_moving_count: reportData.slow_moving_products?.length || 0,
      adjustments_count: reportData.stock_adjustments?.length || 0,
    },
    inventory_register: reportData.inventory_register,
    low_stock_items: reportData.low_stock_items,
    stock_adjustments: reportData.stock_adjustments || [],
  } : null;

  return (
    <ReportPrintLayout
      reportData={printData}
      dateRange={dateRange}
      reportType="inventory"
    />
  );
};

export default ReportsInventoryPrint;